// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  return state.name;
}

function set(_state, field, value) {
  return {
    name: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function normalizeName(name) {
  return name.trim().toLowerCase();
}

function PersonRename(props) {
  let onSubmit = props.onSubmit;
  let existingNames = props.existingNames;
  let normalizedExistingNames = React.useMemo(() => existingNames.map(normalizeName), [existingNames]);
  let form = Form.use({
    name: props.initialName
  }, Validators$1.schema([Validators$1.custom(param => {
      let trimmed = param.name.trim();
      if (trimmed === "") {
        return {
          TAG: "Error",
          _0: "Jméno je povinné"
        };
      } else if (trimmed.length > 30) {
        return {
          TAG: "Error",
          _0: `Jméno může mít nejvýše ` + (30).toString() + ` znaků`
        };
      } else if (normalizedExistingNames.includes(trimmed.trim().toLowerCase())) {
        return {
          TAG: "Error",
          _0: "Takové jméno již evidujeme"
        };
      } else {
        return "Valid";
      }
    }, "Name")]), param => {
    onSubmit({
      name: param.state.values.name.trim()
    });
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  return <DialogForm.make
    formId={"renamePerson"}
    heading={"Přejmenovat osobu"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <form
        id={"renamePerson"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={"reset"}
        >
          <Form.Field.make
            field={"Name"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"name"}
              inputSlot={<input
                maxLength={30}
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Jméno"}
            />}
          />
        </fieldset>
      </form>
      {tmp}
    </Form.Provider.make>
  </DialogForm.make>;
}

let maxNameLength = 30;

let make = PersonRename;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  maxNameLength,
  normalizeName,
  make,
}
/* Form Not a pure module */
